import XTableNamer from "./XTableNamer.js";
import * as Excel from "exceljs/dist/exceljs.min.js";

import {
  saveAs
} from 'file-saver'

/**
 * Exceldownload working with NSWOW2 Tables
 */
class XDownloader {
  constructor(config = {}) {
    const {
      tableTitle,
      tableSelector,
      excludeTableSelector,
      downloadText, // Text for downloadbutton, can be empty if you want to use an icon
      styles, // cell Styles from classes
      numFmt, // numFmt overwrite for custom formatting
      mergeStrings, // Set mergeStrings for all Tables
      tableCellFormatter,
      footnoteFormatter,
    } = config;

    const env = this.getEnvironement();

    this.excludeTableSelector = excludeTableSelector || null;
    this.tableSelector = tableSelector || '.lc-table-wrap';
    this.downloadText = downloadText || 'Excel speichern'; //Text on button, can be empty
    this.tableTitle = tableTitle || null;
    this.styles = styles.map(item => { if (!item.index) item.index = 0; return item; }) || {};
    this.numFmt = numFmt || function (cell) { }
    this.mergeStrings = mergeStrings || [];
    this.tableCellFormatter = tableCellFormatter || this.htmlTableCellFormatter;
    this.footnoteFormatter = footnoteFormatter || this.footnoteFormatter;

    const tables = Array.prototype.slice.call(document.querySelectorAll(this.tableSelector)).filter(table => {
      if (!this.excludeTableSelector) return true;

      const finding = table.querySelector(this.excludeTableSelector);

      if (!!finding) return false;

      return true;
    });

    new XTableNamer();

    tables.forEach(table => {
      if (this.checkTable(table)) {
        this.addLink(table);
      } else if (env === 'stage') {
        this.addLink(table, true);
      }
    });
  }

  checkTable(table) {
    /*const TDs = Array.prototype.slice.call( table.querySelectorAll('tr:first-child > td') );
    let rt = true;
    TDs.forEach( td => {
      if(td.colSpan > 1) rt = false;
    } );*/
    return true;
  }

  createWorkbook(table) {
    this.name = table.querySelector('[data-tableid]').dataset.tableid //if you have an error on this line replace data-tableid with data-table-id & tableid to tableId
    const workbook = new Excel.Workbook();
    this.worksheet = workbook.addWorksheet(this.name);
    this.fileName = this.getFileTitle(table);
    try {
      this.parseTable(table);
      this.parseFootnote(table);
      this.mergeCells(table);
      this.saveFile(this.fileName, workbook);
    } catch (err) {
      alert(`Die Tabelle hat verbundene Zellen in der ersten Reihe, das wird nicht unterstützt vom XDownloader.
      Falls verbundene Zellen in der ersten Reihe benötigt werden bitte erste Zeile leer mit der Klasse .excel-download erfassen`);
      console.error(err)
    }
  }

  mergeCells(table) {
    this.mergeStrings = this.mergeStrings.filter((value, index) => {
      // console.log('merge string' + value, index, this.mergeStrings.indexOf(value))
      return this.mergeStrings.indexOf(value) === index;
    })

    this.mergeStrings.forEach(s => {
      try {
        this.worksheet.mergeCells(s.trim());
      } catch (error) {
        console.error(error);
      }
    });
  }

  /**
   * This one parses the footnotes and puts it after the table content in the worksheet
   * @param {*} table
   */
  parseFootnote(table) {
    const footnotes = Array.prototype.slice.call(table.querySelectorAll('p.ns-footnote'));
    this.worksheet.addRow([]);
    footnotes.forEach(fn => {
      let prettyFootnote = this.footnoteFormatter.call(this, fn);
      this.worksheet.addRow([prettyFootnote]);
    });
  }

  footnoteFormatter(footnote) {
    return footnote.innerText.replace('\n', ' ');
  }

  getFileTitle(elem) {
    let name = elem.querySelector('[data-tableid]').dataset.tableid;
    if (name) name = name.replaceAll(/\./g, '');
    return name;
  }

  getTitle(elem) {
    return elem.closest(this.tableSelector).dataset.xTitle;
  }

  htmlTableCellFormatter(td) {
    let cell = document.createElement('td');
    cell.innerHTML = td.innerHTML;
    let superscript = cell.querySelector('.superscript');
    let superscriptContent = '';
    if (superscript) {
      superscriptContent = '(' + superscript.innerText + ')';
      superscript.parentNode.removeChild(superscript);
    }
    if (td.querySelector('.note__link')) {
      return this.correctNote(cell.innerText.trim() + ' ' + superscriptContent);
    } else {
      return this.correct(cell.innerText.trim() + ' ' + superscriptContent);
    }
  }

 /**
   * This one parses the table and puts it into the worksheet
   * @param {*} table
   */
  parseTable(table) {
    const t = table.querySelector('table');
    const rows = Array.prototype.slice.call(t.querySelectorAll('tr'));
    let content = [];
    let styles = [];

    // Matrix to track merged cells
    let matrix = [];

    // Initialize matrix
    for (let i = 0; i < rows.length; i++) {
      matrix[i] = [];
    }

    // First pass: analyze rowspans and fill matrix
    let rowIndex = 0;
    rows.forEach(r => {
      let colIndex = 0;
      let tds = r.querySelectorAll('th, td');

      tds.forEach(td => {
        // Skip columns that are already occupied by rowspans
        while (matrix[rowIndex] && matrix[rowIndex][colIndex]) {
          colIndex++;
        }

        // Ensure rowSpan and colSpan are valid numbers
        const rowSpan = td.hasAttribute('rowspan') ? parseInt(td.rowSpan) || 1 : 1;
        const colSpan = td.hasAttribute('colspan') ? parseInt(td.colSpan) || 1 : 1;

        // Fill matrix for this cell and its spans
        for (let i = 0; i < rowSpan; i++) {
          for (let j = 0; j < colSpan; j++) {
            if (matrix[rowIndex + i]) {
              matrix[rowIndex + i][colIndex + j] = {
                content: i === 0 && j === 0 ? td : null,
                isSpanned: i !== 0 || j !== 0,
                originalCell: td,
                isPartOfColspan: j > 0  // New flag to track colspan parts
              };
            }
          }
        }

        // Important: increment colIndex by actual colspan
        colIndex += colSpan;
      });
      rowIndex++;
    });


    // Second pass: create Excel rows using matrix
    let counterR = 0;
    const title = this.getTitle(table);

    this.setColumnWidthByHeader(rows);

    matrix.forEach((row, rowIndex) => {
      styles = [];
      content = [];
      counterR++;
      let counterC = 0;

      row.forEach((cell, colIndex) => {
        // Skip cells that are part of a colspan
        if (cell?.isPartOfColspan) {
          return;
        }

        counterC++;

        if (!cell || cell.isSpanned) {
          content.push('');
          return;
        }

        const td = cell.content;
        styles[counterC] = this.getStyles(td);
        let c = this.tableCellFormatter.call(this, td);

        if (isNaN(c)) {
          c = c;
        } else {
          if (c == '\u00A0' || c.trim() == '') { //apparently this is still considered not NaN
            c = c;
          } else {
            c = parseFloat(c);
          }
        }

        content.push(c);

        // Handle colspan and rowspan merges
        if (td.hasAttribute('colspan') || td.hasAttribute('rowspan')) {
          // Handle colspan
          if (td.hasAttribute('colspan')) {
            const colspan = parseInt(td.colSpan) || 1;
            if (colspan > 1) {
              // Add empty cells for colspan
              for (let i = 1; i < colspan; i++) {
                content.push('');
                counterC++;
              }

              // Create merge string for colspan
              const colMergeString = `${this.getLetter(counterC - colspan + 1)}${counterR + (!this.tableTitle ? 1 : 4)}:${this.getLetter(counterC)}${counterR + (!this.tableTitle ? 1 : 4)}`;
              this.mergeStrings.push(colMergeString);
            }
          }

          // Handle rowspan - only if we're not in a spanned cell
          if (td.hasAttribute('rowspan') && !cell.isSpanned) {
            const rowspan = parseInt(td.rowSpan) || 1;
            if (rowspan > 1) {
              // Verify that we actually have cells to span
              let canSpan = true;
              for (let i = 1; i < rowspan; i++) {
                if (!matrix[rowIndex + i] || matrix[rowIndex + i][colIndex]?.originalCell !== td) {
                  canSpan = false;
                  break;
                }
              }

              if (canSpan) {
                const rowMergeString = `${this.getLetter(counterC)}${counterR + (!this.tableTitle ? 1 : 4)}:${this.getLetter(counterC)}${counterR + rowspan - 1 + (!this.tableTitle ? 1 : 4)}`;
                this.mergeStrings.push(rowMergeString);
              }
            }
          }
        }
      });

      // Add row to worksheet
      this.worksheet.addRow(content);
      let wsRow = this.worksheet.lastRow;

      // Apply styles
      for (let i = 1; i < styles.length; i++) {
        if (styles[i]) {
          if (styles[i].alignment) wsRow.getCell(i).alignment = styles[i].alignment;
          if (styles[i].border) wsRow.getCell(i).border = styles[i].border;
          if (styles[i].font) wsRow.getCell(i).font = styles[i].font;
          if (styles[i].fill) wsRow.getCell(i).fill = styles[i].fill;
        }
        if (this.numFmt) {
          this.numFmt.call(this, wsRow.getCell(i), i, counterR);
        }
      }
    });
  }

  setColumnWidthByHeader(rows) {
    const headerClasses = ['excel_download', ...this.styles.filter(item => item.head).map(item => item.class)];
    let isHeader = false;
    let first = true;
    let content = [];
    let headerRow = null;
    let exceldownload = rows.filter(row => row.classList.contains('excel_download'));

    if (!!exceldownload[0]) {
      headerRow = exceldownload[0];
    } else {
      rows.forEach(r => {
        if (first) {
          headerClasses.forEach(item => {
            if (r.classList.contains(item))
              isHeader = true;
            headerRow = r;
          });
        }
      });
    }


    if (headerRow) {
      first = false;

      const tds = Array.prototype.slice.call(headerRow.querySelectorAll('td'));

      tds.forEach(t => { //first iteration for header column without content to set widths of columns
        content.push({
          header: ' ',
          key: 'id',
          width: t.offsetWidth / 7
        });
      });
      this.worksheet.columns = content;

      content = [];

      let row = this.worksheet.lastRow;
      row.height = 0.5;

      if (this.tableTitle) {
        let title = '';
        if (typeof this.tableTitle == 'string') {
          title = this.tableTitle + ' ' + this.fileName.replaceAll('_', ' ');
        } else if (typeof this.tableTitle == 'function') {
          title = this.tableTitle.call(this, table) + ' ' + this.fileName.replaceAll('_', ' ');
        }

        this.worksheet.addRow([]);

        this.worksheet.addRow([title]);
        row = this.worksheet.lastRow;

        row.getCell('A').font = {
          size: 16,
          bold: true
        };

        this.worksheet.addRow([]);
      }
    }
    else {
      return;
    }
  }

  /**
   * check for classes and return the right styles
   * can be extended
   * @param {*} t
   */
  getStyles(t) {
    let r = [];

    const styles = this.styles.filter((style) => {
      return t.classList.contains(style.class);
    }).sort((a, b) => {
      // sort index of importance lowest first
      if (a.index < b.index) {
        return 1;
      }

      if (a.index > b.index) {
        return -1;
      }

      return 0;
    });

    if (t.classList.contains('ns-horizontal-left')) {
      r.alignment = { horizontal: 'left', wrapText: true, vertical: 'top' }
    }
    if (t.classList.contains('ns-horizontal-right')) {
      r.alignment = { horizontal: 'right', wrapText: true, vertical: 'top' }
    }
    if (t.classList.contains('ns-horizontal-center')) {
      r.alignment = { horizontal: 'center', wrapText: true, vertical: 'top' }
    }

    // merge all styles, most important style is applied last
    if (styles.length > 0) {
      styles.forEach(style => {
        r = {
          ...r,
          ...style,
          class: undefined, // remove classes
          head: undefined,
          index: undefined
        };
      });
    }

    // if no border style set
    if (!'border' in r) {
      // console.log(r)
      r.border = {};
    }

    // when no fill set, default to white to hide lines
    if (!!!r.fill || !!!r.fill.fgColor) {
      r.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'FFFFFFFF'
        }
      };
    }

    r.colspan = t.colSpan;

    return r;
  }


  /**
   * add the link to the table
   * @param {*} table
   */
  // addLink(table, error) {
  //   let link = document.createElement('a');
  //   link.classList.add('lc-exceldl-link');
  //   link.classList.add('lc-button');

  //   let svg = `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.3536 7.86674C11.5488 7.67147 11.5488 7.35489 11.3536 7.15963C11.1583 6.96437 10.8417 6.96437 10.6464 7.15963L8.5 9.30608V2.51318C8.5 2.23704 8.27614 2.01318 8 2.01318C7.72386 2.01318 7.5 2.23704 7.5 2.51318L7.5 9.30608L5.35355 7.15963C5.15829 6.96437 4.84171 6.96437 4.64645 7.15963C4.45118 7.35489 4.45118 7.67147 4.64645 7.86674L7.64645 10.8667C7.84171 11.062 8.15829 11.062 8.35355 10.8667L11.3536 7.86674ZM14 10.0132V13.0132L2 13.0132L2 10.0132L3 10.0132V9.01318H1.97383C1.38688 9.01318 1 9.49689 1 10.0132V13.0132C1 13.5655 1.44772 14.0132 2 14.0132L14 14.0132C14.5523 14.0132 15 13.5655 15 13.0132V10.0132C15 9.46975 14.5655 9.02873 14.0278 9.01318H13V10.0132H14Z" fill="#00376E"/></svg>`;

  //   if (error) {
  //     link.classList.add('error');
  //     console.log('error');
  //   }
  //   let currentUrl = window.location.href;
  //   const translations = this.downloadText;
  //   let selectedTranslation = translations.find(translation => currentUrl.includes(`/${translation.lang}/`));

  //   if (selectedTranslation) {
  //     this.downloadText = selectedTranslation.text;
  //   } else {
  //     // Default to English if no match is found
  //     this.downloadText = translations.find(translation => translation.lang === 'en').text;
  //   }
  //   link.innerText = this.downloadText;
  //   link.innerHTML += svg;
  //   link.href = '#';

  //   table.querySelector('& > div').prepend(link);

  //   link.addEventListener('click', (e) => {
  //     e.preventDefault();
  //     this.mergeStrings = [];
  //     this.createWorkbook(table);
  //   });
  // }

  addLink(table, error) {
    let link = document.createElement('a');
    link.classList.add('lc-exceldl-link', 'lc-button');

    let svg = `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.3536 7.86674C11.5488 7.67147 11.5488 7.35489 11.3536 7.15963C11.1583 6.96437 10.8417 6.96437 10.6464 7.15963L8.5 9.30608V2.51318C8.5 2.23704 8.27614 2.01318 8 2.01318C7.72386 2.01318 7.5 2.23704 7.5 2.51318L7.5 9.30608L5.35355 7.15963C5.15829 6.96437 4.84171 6.96437 4.64645 7.15963C4.45118 7.35489 4.45118 7.67147 4.64645 7.86674L7.64645 10.8667C7.84171 11.062 8.15829 11.062 8.35355 10.8667L11.3536 7.86674ZM14 10.0132V13.0132L2 13.0132L2 10.0132L3 10.0132V9.01318H1.97383C1.38688 9.01318 1 9.49689 1 10.0132V13.0132C1 13.5655 1.44772 14.0132 2 14.0132L14 14.0132C14.5523 14.0132 15 13.5655 15 13.0132V10.0132C15 9.46975 14.5655 9.02873 14.0278 9.01318H13V10.0132H14Z" fill="#00376E"/></svg>`;

    if (error) {
        link.classList.add('error');
    }

    let currentUrl = window.location.href;

    const translations = Array.isArray(this.downloadText) && this.downloadText.length > 0
        ? this.downloadText
        : [
            { lang: 'de', text: 'Excel speichern' },
            { lang: 'en', text: 'Save Excel' }
        ];

    let selectedTranslation = translations.find(translation => {

        return currentUrl.includes(`/${translation.lang}/`);
    });

    this.downloadText = selectedTranslation?.text || translations.find(t => t.lang === 'en')?.text || 'Download';

    link.innerHTML = `${this.downloadText} ${svg}`;
    link.href = '#';

    let targetDiv = table.querySelector(':scope > div');
    if (targetDiv) {
        targetDiv.prepend(link);
    } else {
        console.warn('No suitable div found inside the table to insert the link.');
    }

    link.addEventListener('click', (e) => {
        e.preventDefault();
        this.mergeStrings = [];
        this.createWorkbook(table);
    });
}






  /**
   * savefile doesnt need explanation as well
   * @param {*} fileName
   * @param {*} workbook
   */
  async saveFile(fileName, workbook) {
    const xls64 = await workbook.xlsx.writeBuffer({
      base64: true
    })
    saveAs(
      new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }),
      fileName
    )
  }



  /**
   * delete the thousand marks and replace false minus with right one
   */
  correct(text) {
    return text.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-').replace(/,/g, '.').replace(/–/g, '-').replace(/,/g, '.');
  }
  correctNote(text) {
    return text.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-');
  }


  getLetter(number) {
    const letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    return letters[number - 1];
  }

  getEnvironement() {
    const body = document.querySelector('body');
    if (body.classList.contains('wp-production')) {
      return 'production';
    } else {
      return 'stage';
    }
  }

}
export default XDownloader;

